export * from './url'
export * from './cookies'
export * from './booleans'
export * from './userBg'
export * from './NavbarModuleNavigator'
export * from './phoneBind'

export const isSafari = () => {
  return (
    // @ts-ignore
    typeof window.safari === 'object' || (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))
  )
}

export const formatNumberWithCommas = (num: number) => {
  return num.toLocaleString('en-US')
}
